import * as React from 'react'
import type { RouteObject } from 'react-router'

const Campaigns = React.lazy(() => import('../views/Campaigns/Campaigns'))

export const CampaignRouter: RouteObject[] = [
    {
        path: '/campaign',
        element: <Campaigns />,
    },
]
